module.exports = __webpack_public_path__ + "img/weChat_supplier.2d008e85.png";